var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_Kopie"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100,
    y1: 102,
    x2: 100,
    y2: 2,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#95C120",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#95C120"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M173,100c0,40.3-32.7,73-73,73s-73-32.7-73-73H0v100h200V100H173z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Auszubildende_x2F_-r_Form"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M53.7,177.2l0.8-2l-2.1-1.3l-1.5,1.6l-1.9-1.2l7.4-6.8l2.3,1.4l-2.9,9.6L53.7,177.2z M53.5,172.7l1.5,1 l1.5-4.2L53.5,172.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M61.8,181.6l-1.7-0.9l0.3-0.8c-0.8,0.5-1.5,0.5-2.3,0.1c-0.5-0.3-0.9-0.7-1-1.2s0-1.1,0.3-1.7l2.5-4.9 l1.9,1l-2.4,4.7c-0.2,0.5-0.2,0.8,0.1,1c0.3,0.2,0.7,0.1,1.2-0.3l2.4-4.7l1.9,1L61.8,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M70,176.9c0.3,0.3,0.6,0.7,0.8,1.1l-1.2,0.8c-0.4-0.5-0.8-0.9-1.3-1.1c-0.2-0.1-0.4-0.1-0.6-0.1 c-0.2,0-0.3,0.2-0.4,0.3c-0.1,0.1-0.1,0.3,0,0.4s0.1,0.3,0.3,0.4c0.1,0.2,0.4,0.4,0.7,0.7c0.5,0.5,0.9,0.9,1.1,1.4 c0.2,0.5,0.1,1-0.1,1.5c-0.3,0.7-0.8,1.1-1.5,1.3c-0.7,0.2-1.5,0.1-2.3-0.2c-0.5-0.2-1-0.5-1.4-0.9c-0.4-0.4-0.7-0.8-0.9-1.2 l1.4-0.7c0.4,0.7,0.8,1.1,1.3,1.3c0.3,0.1,0.5,0.1,0.7,0.1s0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.3-0.2-0.4 s-0.4-0.4-0.7-0.7c-0.5-0.5-0.9-0.9-1-1.4c-0.2-0.5-0.1-0.9,0.1-1.4c0.2-0.4,0.4-0.7,0.8-0.9c0.3-0.2,0.7-0.4,1.2-0.4 c0.5,0,1,0.1,1.5,0.3C69.2,176.4,69.6,176.6,70,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.7,179.3l-0.5,1.4l-4.2,3.1l3,1l-0.7,1.5l-5.1-1.7l0.5-1.4l4.2-3.1l-2.6-0.9l0.5-1.5L76.7,179.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.2,188.1l-1.8-0.4l0.1-0.9c-0.7,0.6-1.4,0.8-2.2,0.6c-0.6-0.1-1-0.5-1.2-0.9c-0.2-0.5-0.3-1-0.1-1.7 l1.3-5.3l2.1,0.5l-1.3,5.1c-0.1,0.5,0,0.8,0.4,0.9c0.4,0.1,0.7-0.1,1.1-0.6l1.3-5.1l2.1,0.5L81.2,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M90,182.8c0.3,0.7,0.4,1.7,0.2,3c-0.1,0.8-0.3,1.4-0.6,2s-0.7,1-1.1,1.2c-0.4,0.3-0.9,0.4-1.5,0.3 c-0.4-0.1-0.7-0.2-0.9-0.4s-0.5-0.5-0.7-0.8l-0.2,0.7l-1.9-0.3l1.6-10.3l2.2,0.1l-0.6,3.9c0.2-0.3,0.5-0.5,0.9-0.6 c0.3-0.1,0.7-0.2,1.1-0.1C89.1,181.6,89.6,182.1,90,182.8z M87.4,187.2c0.2-0.3,0.4-0.9,0.6-1.8c0.1-0.9,0.2-1.5,0-1.9 c-0.1-0.4-0.3-0.6-0.6-0.6c-0.2,0-0.4,0-0.6,0.1s-0.4,0.3-0.6,0.5l-0.5,3.2c0.2,0.5,0.5,0.8,0.9,0.8 C86.9,187.7,87.2,187.6,87.4,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93.9,182.4l-0.6,7.4l-2.1-0.2l0.6-7.4L93.9,182.4z M94,178.8c0.2,0.3,0.3,0.6,0.3,0.9 c0,0.4-0.2,0.6-0.4,0.8c-0.3,0.2-0.6,0.3-0.9,0.3c-0.4,0-0.7-0.2-0.9-0.4c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.3,0.2-0.6,0.4-0.8 c0.3-0.2,0.6-0.3,0.9-0.3C93.5,178.4,93.8,178.6,94,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M95.5,189.6c-0.3-0.4-0.5-0.9-0.5-1.5l0.4-8.6l2.2-0.1l-0.4,8.7c0,0.3,0.1,0.4,0.3,0.4c0.1,0,0.2,0,0.3,0 l0.3,1.5c-0.4,0.2-0.8,0.2-1.3,0.2C96.3,190.2,95.8,190,95.5,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105,179.5l0.3,10.4l-1.9,0l-0.1-0.8c-0.5,0.7-1.1,1.1-1.9,1.1c-0.8,0-1.5-0.3-1.9-1 c-0.5-0.7-0.7-1.7-0.7-2.9c0-0.8,0.1-1.5,0.3-2.1c0.2-0.6,0.5-1.1,0.9-1.4c0.4-0.3,0.9-0.5,1.4-0.5c0.6,0,1.1,0.2,1.6,0.6 l-0.1-3.6L105,179.5z M102.6,188.4c0.2-0.1,0.3-0.3,0.5-0.6l-0.1-3.4c-0.2-0.2-0.3-0.3-0.5-0.4c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.7,0-1.1,0.8-1.1,2.4c0,0.9,0.1,1.5,0.3,1.8s0.4,0.5,0.8,0.5C102.3,188.6,102.5,188.6,102.6,188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.9,186l-4.1,0.5c0.1,0.6,0.3,1.1,0.6,1.3s0.6,0.3,1,0.3c0.3,0,0.5-0.1,0.8-0.2 c0.2-0.1,0.5-0.3,0.8-0.6l1,1.1c-0.7,0.8-1.5,1.2-2.5,1.3c-1.1,0.1-2-0.1-2.7-0.8c-0.7-0.6-1.1-1.5-1.2-2.8c-0.1-1.2,0-2.2,0.5-3 c0.5-0.8,1.2-1.2,2.2-1.4c1-0.1,1.8,0.1,2.4,0.7c0.6,0.6,1,1.5,1.1,2.7C112.9,185.5,112.9,185.8,112.9,186z M110.7,184.9 c-0.1-0.6-0.2-1-0.4-1.3s-0.5-0.4-0.8-0.4c-0.3,0-0.6,0.2-0.7,0.5s-0.2,0.8-0.2,1.5L110.7,184.9L110.7,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M118.8,180.8c0.4,0.3,0.7,0.8,0.8,1.5l1.1,5.4l-2.1,0.4l-1-5.1c-0.1-0.3-0.1-0.5-0.3-0.6 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0.1-0.5,0.3c-0.1,0.2-0.3,0.4-0.4,0.8l1,5l-2.1,0.4l-1.5-7.3l1.9-0.4l0.3,0.8 c0.2-0.4,0.4-0.8,0.7-1s0.6-0.4,1-0.5C117.9,180.4,118.4,180.5,118.8,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M125.5,175.5l2.9,10l-1.8,0.5l-0.3-0.8c-0.3,0.8-0.8,1.3-1.5,1.6c-0.8,0.2-1.5,0.1-2.1-0.5 c-0.6-0.5-1.1-1.4-1.5-2.6c-0.2-0.8-0.3-1.4-0.3-2.1c0-0.6,0.2-1.2,0.5-1.6s0.7-0.7,1.2-0.9c0.6-0.2,1.2-0.1,1.7,0.2l-1-3.5 L125.5,175.5z M125.5,184.7c0.1-0.2,0.2-0.4,0.3-0.7l-1-3.2c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2-0.1-0.3-0.1-0.5,0 c-0.7,0.2-0.9,1.1-0.4,2.6c0.3,0.9,0.5,1.4,0.8,1.7c0.3,0.3,0.6,0.4,0.9,0.3C125.2,185,125.4,184.9,125.5,184.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M134.8,179.7l-3.9,1.5c0.3,0.6,0.6,1,0.9,1.1c0.3,0.1,0.7,0.1,1.1,0c0.3-0.1,0.5-0.2,0.7-0.4 c0.2-0.2,0.4-0.4,0.6-0.7l1.3,0.8c-0.5,0.9-1.2,1.6-2.1,1.9c-1,0.4-2,0.4-2.8,0c-0.8-0.4-1.4-1.2-1.9-2.4c-0.4-1.1-0.5-2.1-0.3-3 s0.9-1.5,1.8-1.9c0.9-0.4,1.8-0.3,2.5,0.1c0.8,0.4,1.4,1.2,1.8,2.3C134.7,179.3,134.8,179.5,134.8,179.7z M132.4,179.2 c-0.2-0.5-0.4-0.9-0.7-1.1c-0.3-0.2-0.5-0.3-0.9-0.1c-0.3,0.1-0.5,0.3-0.6,0.7c-0.1,0.3,0,0.8,0.2,1.5L132.4,179.2L132.4,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M135.2,170.3l1.8-0.4l2.8,12.6l-1.9,0.4L135.2,170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M141.7,175.8l-0.8-1.5l3.5-2.1l0.8,1.5L141.7,175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M148,167.1l0.9,1.9c-0.2,0.1-0.4,0.1-0.5,0.3c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.4,0.1,0.8,0.3,1.4l2.1,3.2 l-1.8,1.2l-4.1-6.2l1.6-1.1l0.9,1c-0.1-0.5-0.1-0.9,0-1.3s0.3-0.7,0.7-0.9C147.6,167.3,147.8,167.2,148,167.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainee);
export default __webpack_public_path__ + "static/media/trainee.c788f2d55a61b9464541f7c444faa989.svg";
export { ForwardRef as ReactComponent };